module.exports = "<div class=\"container\">\n    <h1>Veuillez créer votre organisation</h1>\n    <form (ngSubmit)=\"newBusiness()\" #businessForm=\"ngForm\">\n        <div class=\"form-group\">\n            <label for=\"name\">Nom de l'organisation</label>\n            <input type=\"text\" class=\"form-control\" id=\"name\" required [(ngModel)]=\"model.name\" name=\"name\" placeholder=\"Nom de l'organisation\">\n        </div>\n\n        <button type=\"submit\" class=\"btn btn-primary\" [disabled]=\"submitted\">Créer mon organisation</button>\n\n    </form>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/business/form/business-form.component.html
// module id = 248
// module chunks = 0